export default {
  accessDenied: 'access_denied',
  notFound: 'not_found',
};
